
export const ESPECIFICACAO_REPORT_MAPPER = {
    'localizado_entre_dentes': {
        posicao: 'antes',
        texto: {
            singular: 'localizado entre os dentes',
            plural: 'localizado entre os dentes',
        }
    },
    'localizado_distal_dente': {
        posicao: 'antes',
        texto: {
            singular: 'localizado à distal do dente',
            plural: 'localizado à distal do dente',
        }
    },
    'localizado_entre_raizes_dentes': {
        posicao: 'antes',
        texto: {
            singular: 'localizado entre as raízes dos dentes',
            plural: 'localizado entre as raízes dos dentes',
        }
    },
    'localizado_entre_raizes_dente': {
        posicao: 'antes',
        texto: {
            singular: 'localizado entre as raízes do dente',
            plural: 'localizado entre as raízes do dente',
        }
    },
    'localizado_distal_raiz_dente': {
        posicao: 'antes',
        texto: {
            singular: 'localizado à distal da raiz do dente',
            plural: 'localizado à distal da raiz do dente',
        }
    },
    'localizado_acima_dente': {
        posicao: 'antes',
        texto: {
            singular: 'localizado acima do dente',
            plural: 'localizado acima dos dentes',
        }
    },
    'localizado_abaixo_dente': {
        posicao: 'antes',
        texto: {
            singular: 'localizado abaixo do dente',
            plural: 'localizado abaixo dos dentes',
        }
    },
    'localizado_mandibula_abaixo_dente': {
        posicao: 'antes',
        texto: {
            singular: 'localizado na base da mandíbula, abaixo do dente',
            plural: 'localizado na base da mandíbula, abaixo dos dentes',
        }
    },
    'regiao_dente': {
        posicao: 'antes',
        texto: {
            singular: 'na região do dente',
            plural: 'na região do dente',
        }
    },
    'regiao_dentes': {
        posicao: 'antes',
        texto: {
            singular: 'na região do dente',
            plural: 'na região dos dentes',
        }
    },
    'provavel_regiao_dente': {
        posicao: 'antes',
        texto: {
            singular: 'na provável região do dente',
            plural: 'na provável região do dente',
        }
    },
    'provavel_regiao_dentes': {
        posicao: 'antes',
        texto: {
            singular: 'na provável região do dente',
            plural: 'na provável região dos dentes',
        }
    },
    'regiao_palatina': {
        posicao: 'antes',
        texto: {
            singular: 'na região palatina',
            plural: 'na região palatina',
        },
    },
    'entre_dentes': {
        posicao: 'antes',
        texto: {
            singular: 'entre os dentes',
            plural: 'entre os dentes',
        }
    },
    'proximo_apice_dente': {
        posicao: 'antes',
        texto: {
            singular: 'próximo ao ápice do dente',
            plural: 'próximo ao ápice dos dentes',
        }
    },
    'proximo_dente': {
        posicao: 'antes',
        texto: {
            singular: 'próximo ao dente',
            plural: 'próximo aos dentes',
        }
    },
    'proximo_regiao_dente': {
        posicao: 'antes',
        texto: {
            singular: 'próximo à região do dente',
            plural: 'próximo à região dos dentes',
        }
    },
    'proximo_regiao_anatomica': {
        posicao: 'antes',
        texto: {
            singular: 'próximo à região anatômica',
            plural: 'próximo às regiões anatômicas',
        }
    },
    'abaixo_dente': {
        posicao: 'antes',
        texto: {
            singular: 'abaixo do dente',
            plural: 'abaixo dos dentes',
        }
    },
    'acima_dente': {
        posicao: 'antes',
        texto: {
            singular: 'acima do dente',
            plural: 'acima dos dentes',
        }
    },
    'distal_dente': {
        posicao: 'antes',
        texto: {
            singular: 'à distal do dente',
            plural: 'à distal dos dentes',
        }
    },
    'entre_raizes_dentes': {
        posicao: 'antes',
        texto: {
            singular: 'entre as raízes dos dentes',
            plural: 'entre as raízes dos dentes',
        }
    },
    'distal_raiz_dente': {
        posicao: 'antes',
        texto: {
            singular: 'à distal da raiz do dente',
            plural: 'à distal das raízes dos dentes',
        }
    },
    'para_direita': {
        posicao: 'antes',
        texto: {
            singular: 'para a direita',
            plural: 'para a direita',
        }
    },
    'para_esquerda': {
        posicao: 'antes',
        texto: {
            singular: 'para a esquerda',
            plural: 'para a esquerda',
        }
    },
    'direito': {
        posicao: 'antes',
        texto: {
            singular: 'lado direito',
            plural: 'lado direito',
        }
    },
    'esquerdo': {
        posicao: 'antes',
        texto: {
            singular: 'lado esquerdo',
            plural: 'lado esquerdo',
        }
    },
    'ambos': {
        posicao: 'antes',
        texto: {
            singular: 'ambos os lados',
            plural: 'ambos os lados',
        }
    },
}